// zurylive: API escolhida pelo HOSTNAME, igual à roleta e à loteria do
// zury. Hostname com "-dev" (gold-miner-video-dev.pages.dev, gold-miner-dev.zurylive.com)
// ou local → dev; o resto → prod. Não depende de .env (que é gitignored), então um
// clone limpo builda e o guard (scripts/verify-api.mjs) vê as duas URLs de propósito.
const isDev = () => {
  const h = window.location.hostname
  return (
    h === 'localhost' ||
    h === '127.0.0.1' ||
    h.startsWith('192.168.') ||
    h.includes('-dev')
  )
}

export const API_URL = () =>
  isDev()
    ? 'https://api-isolate-dev.zurylive.com'
    : 'https://api-isolate.zurylive.com'

